import { useUsersQuery } from '@/features/users/hooks/useUsersQuery';
import { UserDataTable } from '@/features/users/components/UserDataTable';

interface DealerUsersProps {
  dealerId: string;
}

export function DealerUsers({ dealerId }: DealerUsersProps) {
  const query = useUsersQuery({ dealer_id: dealerId, per_page: 50 });

  return (
    <div className="space-y-4">
      <UserDataTable
        data={query.data?.users ?? []}
        isLoading={query.isLoading}
        emptyMessage="No users assigned to this dealer yet."
      />
    </div>
  );
}
